/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  Radio,
  RadioGroup,
  Stack,
  Switch,
  TextField,
  Typography
} from "@mui/material";
import Select from "react-select";
import { DeleteSharp } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import moment from "moment";
import { PollSelect } from "src/utils/common";
import ScheduleEntryList from "../Notification/ScheduleEntryList";

function PollForm({
  getdata,
  setgetdata,
  answer,
  setanswer,
  editingPoll,
  showValidation,
  setShowValidation,
  isLoading,
  loginUser,
  onSubmit,
  onCancel,
  scheduleReadOnly,
  onScheduleEntryRemove
}) {
  const [option, setOption] = useState([]);

  const getOptionsValueList = async (type = 0) => {
    let optiondata = [];
    if (type != 0) {
      const resp = await PollSelect(type, loginUser?.u_type, loginUser?.city_id);
      resp?.map((e) => optiondata.push({ value: e.value, label: e.name }));
      setOption(optiondata);
    }
  };

  useEffect(() => {
    if (getdata.p_type != 0) {
      getOptionsValueList(getdata.p_type);
    }
  }, [getdata.p_type]);

  const onChangeFunction = (e) => {
    if (e.target.name == "p_type") {
      setOption([]);
      setgetdata({ ...getdata, [e.target.name]: e.target.value, p_type_id: "0" });
    } else {
      setgetdata({ ...getdata, [e.target.name]: e.target.value });
    }
  };

  const addanswer = () => {
    setanswer([...answer, { value: "" }]);
  };

  const handleValueChange = (index, newValue) => {
    const updatedAnswer = [...answer];
    updatedAnswer[index].value = newValue;
    setanswer(updatedAnswer);
  };

  const deleteObject = (index) => {
    setanswer(answer.filter((_, i) => index != i));
  };

  const isAddMode = !editingPoll;

  return (
    <Card style={{ padding: "20px" }}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom style={{ textAlign: "center" }}>
            {isAddMode ? "Add New Poll" : "Edit Poll"}
          </Typography>
          <hr style={{ marginBottom: "0", marginTop: "0" }} />
        </Grid>

        {loginUser?.u_type == 1 ||
        (loginUser?.u_type == 2 && loginUser?.management_p != 0) ? null : (
          <Grid item xs={12}>
            <Stack>
              <FormControl component="fieldset">
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Switch
                        name="show_on_home"
                        checked={getdata.show_on_home == 0 ? false : true}
                        onChange={(e) => {
                          let x = 0;
                          if (e.target.checked == true) x = 1;
                          setgetdata({ ...getdata, [e.target.name]: x });
                        }}
                        value="0"
                      />
                    }
                    label="Show On Home Screen"
                  />
                </FormGroup>
              </FormControl>
            </Stack>
          </Grid>
        )}

        {/* Poll Display */}
        <Grid item xs={12}>
          <FormLabel>Poll Display</FormLabel>
          <Stack spacing={3}>
            <RadioGroup
              row
              value={getdata.p_type != null ? String(getdata.p_type) : ""}
              onChange={onChangeFunction}
              name="p_type"
            >
              {loginUser?.u_type == 0 && (
                <>
                  <FormControlLabel value="0" control={<Radio />} label="LVB" />
                  <FormControlLabel value="1" control={<Radio />} label="State" />
                </>
              )}
              <FormControlLabel value="2" control={<Radio />} label="City" />
              <FormControlLabel value="3" control={<Radio />} label="Chapter" />
            </RadioGroup>
          </Stack>
        </Grid>

        {/* Poll Send To (Privilege only) */}
        <Grid item xs={12}>
          <FormLabel>Poll Send To</FormLabel>
          <Stack spacing={3}>
            <RadioGroup
              row
              value={getdata.p_send_to != null ? String(getdata.p_send_to) : "0"}
              onChange={onChangeFunction}
              name="p_send_to"
            >
              <FormControlLabel value="0" control={<Radio />} label="All" />
              <FormControlLabel value="1" control={<Radio />} label="LT" />
              <FormControlLabel value="2" control={<Radio />} label="Members" />
              <FormControlLabel value="3" control={<Radio />} label="Director" />
            </RadioGroup>
          </Stack>
        </Grid>

        {/* Poll For multi-select */}
        {getdata.p_type != 0 && (
          <Grid item xs={12}>
            <Stack spacing={10} style={{ marginBottom: "15px" }}>
              <label style={{ marginBottom: "10px" }}>
                Select
                {getdata.p_type == 1 ? " State" : getdata.p_type == 2 ? " City" : getdata.p_type == 3 ? " Chapter" : " LVB"}
              </label>
              <Select
                isMulti
                value={
                  option?.filter((opt) => {
                    const raw = (getdata.p_type_id || "0").toString().replace(/^\[|]$/g, "");
                    const ids = raw.split(",").filter(Boolean);
                    return ids.includes(String(opt.value));
                  }) || []
                }
                onChange={(selected) => {
                  const val = selected ? selected.map((s) => s.value).join(",") : "0";
                  setgetdata({ ...getdata, p_type_id: val });
                }}
                menuPortalTarget={document.body}
                options={option}
                placeholder="Select..."
              />
            </Stack>
          </Grid>
        )}

        {/* Poll To (Privilege only) */}
        <Grid item xs={12}>
          <FormLabel>Poll To</FormLabel>
          <Stack spacing={3}>
            <RadioGroup
              row
              value={getdata.p_to != null ? String(getdata.p_to) : "0"}
              onChange={onChangeFunction}
              name="p_to"
            >
              <FormControlLabel value="0" control={<Radio />} label="All" />
              <FormControlLabel value="1" control={<Radio />} label="Not OBT (New Member)" />
              <FormControlLabel value="2" control={<Radio />} label="Not Green Tick (OBT Done)" />
              <FormControlLabel value="3" control={<Radio />} label="Not Blue Tick (V2V Done)" />
              <FormControlLabel value="6" control={<Radio />} label="Blue Tick Done" />
              <FormControlLabel value="4" control={<Radio />} label="Not Fillup V2V Sheet" />
              <FormControlLabel value="5" control={<Radio />} label="Location Not Set" />
              <FormControlLabel value="9" control={<Radio />} label="Not OBT or Not Green Tick" />
              <FormControlLabel value="10" control={<Radio />} label="Not Green Tick or Not Blue Tick" />
              <FormControlLabel value="11" control={<Radio />} label="Not OBT or Not Green Tick or Not Blue Tick" />
            </RadioGroup>
          </Stack>
        </Grid>

        {/* Question */}
        <Grid item xs={12}>
          <Stack spacing={3}>
            <TextField
              required
              fullWidth
              autoComplete="off"
              type="text"
              label="Question"
              name="question"
              onChange={onChangeFunction}
              value={getdata?.question ? getdata?.question : ""}
              error={showValidation && getdata.question == "" ? true : false}
              helperText={showValidation && getdata.question == "" ? "Please Enter Poll Question" : ""}
            />
          </Stack>
        </Grid>

        {/* Answers */}
        <Grid item xs={12}>
          {answer?.map((ans, i) => (
            <Stack key={i} spacing={3} style={{ marginBottom: "15px" }}>
              <Grid container spacing={2}>
                <Grid item xs={11} style={{ paddingLeft: "0px" }}>
                  <TextField
                    fullWidth
                    autoComplete="off"
                    type="text"
                    label="Answer"
                    onChange={(e) => handleValueChange(i, e.target.value)}
                    value={ans.value}
                    error={ans?.value == null}
                    helperText={ans.value == null ? "Please Enter Poll Answer" : ""}
                  />
                </Grid>
                <Grid item xs={1} className="d-flex align-item-center">
                  <IconButton color="error" aria-label="delete" onClick={() => deleteObject(i)}>
                    <DeleteSharp />
                  </IconButton>
                </Grid>
              </Grid>
            </Stack>
          ))}
          <Button onClick={addanswer} style={{ marginTop: "15px" }} variant="contained">
            Add Answer
          </Button>
        </Grid>

        {/* Schedule Entries (Multi-Date) */}
        <Grid item xs={12}>
          <ScheduleEntryList
            entries={getdata.schedule_entries || []}
            setEntries={(entries) => setgetdata({ ...getdata, schedule_entries: entries })}
            isEditMode={!!editingPoll}
            readOnly={scheduleReadOnly}
            onEntryRemove={onScheduleEntryRemove}
          />
        </Grid>

        {/* Submit and Cancel */}
        <Grid item xs={12} spacing={2}>
          <LoadingButton
            type="button"
            variant="contained"
            color="primary"
            sx={{ marginRight: "5px" }}
            loading={isLoading}
            onClick={onSubmit}
          >
            Submit
          </LoadingButton>
          <Button variant="outlined" color="error" onClick={onCancel}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}

export default PollForm;
